import { IConnect, IError } from '@amfi/connect-wallet/dist/interface';

export const isWalletConnectError = (
  item: IConnect | IError | { address: string },
): item is IError => {
  return (item as IError).code !== undefined;
};
